import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../core/models/response.model'
import { ProfileService } from '../../../core/services/profile/profile.service'
import { MatButton } from '@angular/material/button'
import { MatCard, MatCardHeader, MatCardTitle } from '@angular/material/card'
import { MatFormField, MatLabel } from '@angular/material/form-field'
import { MatIcon } from '@angular/material/icon'
import { MatInput } from '@angular/material/input'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { MatSlideToggle } from '@angular/material/slide-toggle'

@Component({
  selector: 'app-profile-edit',
  imports: [
    MatButton,
    MatCard,
    MatCardHeader,
    MatCardTitle,
    MatFormField,
    MatIcon,
    MatInput,
    MatLabel,
    MatProgressSpinner,
    ReactiveFormsModule,
    MatSlideToggle,
  ],
  templateUrl: './profile-edit.component.html',
  styleUrl: './profile-edit.component.scss',
  providers: [ProfileService],
})
export class ProfileEditComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private profileService: ProfileService,
    private snackbar: SnackbarCustomService,
    private dialogRef: MatDialogRef<ProfileEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.item = data
  }

  @Output() responseEdit = new EventEmitter()

  item: any = {}
  form: FormGroup = new FormGroup({})
  loading: boolean = false

  ngOnInit(): void {
    this.createForm()
  }

  updateProfile() {
    this.loading = true
    const model = this.createModel()
    this.profileService.editProfile(model).subscribe({
      next: (response: ResponseRequestModel) => {
        this.snackbar.success(response)
        this.responseEdit.emit(true)
        this.close()
      },
      error: (err: ErrorRequestModel) => {
        this.loading = false
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loading = false
        this.form.reset()
      },
    })
  }

  close() {
    this.dialogRef.close()
  }

  createModel() {
    return {
      id: this.item.id,
      descricao: this.form.controls['description'].value,
      statusId: this.form.get('active')?.value == true ? 1 : 2,
    }
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      code: [{ value: this.item.id, disabled: true }, [Validators.required]],
      description: [this.item.descricao, [Validators.required]],
      active: [this.item.statusId == 1 ? true : false],
    })
  }
}
